module.exports = {
      id: "icon-a-icon-download-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-a-icon-download",
      toString: function () {
        return this.url;
      }
    }